import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'stena-footer',
  imports: [],
  templateUrl: './stena-footer.component.html',
  styleUrls: ['./stena-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StenaFooterComponent {}
